import {
	ApiResponse,
	CountryModel,
	ExtraModel,
	OfferModel,
	ReservationRequestModel,
	ReservationResponseModel,
	SearchRequestModel,
	StationModel,
} from '@/types/api-models'
import { api } from './api'

const TATTERSALL_API_BASE_URL = (
	process.env.NEXT_PUBLIC_TATTERSALL_API_URL ||
	'https://reservas.tattersall.com.co/apieuropcar/api/1.0'
).replace(/\/+$/, '')

const TATTERSALL_STATION_API_URL = (
	process.env.NEXT_PUBLIC_TATTERSALL_STATION_API_URL ||
	'https://reservas.tattersall.com.co/apieuropcar/api/1.0'
).replace(/\/+$/, '')

export const tattersallService = {
	/**
	 * Get all countries
	 */
	getCountries: async (): Promise<ApiResponse<CountryModel[]>> => {
		return api.get<ApiResponse<CountryModel[]>>(
			`${TATTERSALL_API_BASE_URL}/countries`,
		)
	},

	/**
	 * Get all stations
	 */
	getAllStations: async (countryCode?: string): Promise<StationModel[]> => {
		const params = countryCode ? `?countryCode=${countryCode}` : ''
		return api.get<StationModel[]>(
			`${TATTERSALL_STATION_API_URL}/stations${params}`,
		)
	},

	/**
	 * Get station detail by ID (includes open hours)
	 */
	getStationById: async (stationId: string): Promise<StationModel> => {
		return api.get<StationModel>(
			`${TATTERSALL_STATION_API_URL}/Stations/${stationId}`,
		)
	},

	/**
	 * Get extras (additional services)
	 */
	getExtras: async (): Promise<ApiResponse<ExtraModel[]>> => {
		return api.get<ApiResponse<ExtraModel[]>>(
			`${TATTERSALL_API_BASE_URL}/extras`,
		)
	},

	/**
	 * Search for available vehicles
	 */
	searchVehicles: async (
		request: SearchRequestModel,
	): Promise<OfferModel[]> => {
		const params = new URLSearchParams({
			stationPickUp: request.pickupStationId,
			stationReturn: request.dropoffStationId,
			datePickUp: request.pickupDate,
			dateReturn: request.dropoffDate,
			driverAge: String(request.driverAge || 25),
			countryResidence: request.countryCode || 'CO',
			countryCode: request.countryCode || 'CO',
			filterPriceOrder: request.filterPriceOrder || 'pricelow',
			filterPriceMinValue: (request.filterPriceMinValue || 0).toString(),
			filterPriceMaxValue: (
				request.filterPriceMaxValue || 100000000
			).toString(),
			filterSeatsValue: (request.filterSeatsValue || 2).toString(),
			filterTransmissionValue: request.filterTransmissionValue || 'both',
			vehicleType: request.vehicleType || 'coche',
		})

		if (request.promotionalCode?.trim()) {
			params.set('promoCode', request.promotionalCode.trim())
		}

		return api.get<OfferModel[]>(
			`${TATTERSALL_API_BASE_URL}/offers?${params.toString()}`,
		)
	},

	/**
	 * Create reservation
	 */
	createReservation: async (
		reservationData: ReservationRequestModel,
	): Promise<ApiResponse<ReservationResponseModel>> => {
		return api.post<ApiResponse<ReservationResponseModel>>(
			`${TATTERSALL_API_BASE_URL}/offers/reservation`,
			reservationData,
		)
	},
}
